import { Browser } from '@capacitor/browser';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class InAppBrowserService {
  public openUrl(url: string, useSystemBrowser: boolean = false): void {
    if (useSystemBrowser) {
      window.open(url, '_system');

      return;
    }

    Browser.open({
      url,
    }).catch((error) => {
      console.error(error);
    });
  }

  public hide(): void {
    Browser.close().catch((error) => {
      console.error(error);
    });
  }
}
